import WebFont from 'webfontloader'
import { useEffect } from 'react'

import { GoogleFontStyleStrings } from './constants'

// NOTE: it seems web font loader doesn't keep track of loaded fonts, so this
// variable was introduced as a quick fix (since we load ALL fonts).
// If we ever load a subset we need an array of fonts already loaded and only
// load the missing ones.
let loaded = false

// currently this hook loads ALL fonts, but it's easy to hand in a subset if we ever want to optimize that again in the future
export const useEditorFonts = () => {
  useEffect(() => {
    if (loaded) return

    loaded = true
    // see above as for why we don't simply save an array of fonts to load
    const families = Object.keys(GoogleFontStyleStrings)
      .map(
        (fontFamily) =>
          fontFamily in GoogleFontStyleStrings &&
          GoogleFontStyleStrings[fontFamily as keyof typeof GoogleFontStyleStrings],
      )
      .filter(Boolean) as string[]

    if (families.length) {
      const href = `https://fonts.googleapis.com/css2?${families.map((f) => `family=${f}`).join('&')}&display=swap`

      WebFont.load({
        custom: {
          families: families,
          urls: [href],
        },
      })
    }
  }, [])
}

// usage of this is discouraged - it's only used in class components
export const EditorFonts = () => {
  useEditorFonts()

  return null
}
